import {
  DEVICES_AVAILABLE_FETCH_STARTED,
  DEVICES_AVAILABLE_FETCH_SUCCEEDED,
  DEVICES_AVAILABLE_FETCH_FAILED,
  DEVICES_AVAILABLE_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();
export const fetchDevicesAvailable = (serial, dateRange) => async dispatch => {
  try {
    abortController.abort();
    dispatch({
      type: DEVICES_AVAILABLE_FETCH_STARTED
    });

    const params = new URLSearchParams({
      limit: 100,
      engaged: 1
    });
    if (serial) {
      params.set('filterBy', 'title');
      params.set('filter', serial);
      if (serial.length === 1) return;
    }
    if (dateRange) {
      const { start, end } = dateRange;
      if (start) {
        params.set('start', start);
      }
      if (end) {
        params.set('end', end);
      }
    }
    const url = webPortalApi.buildApiUrl(`device/available?${params.toString()}`);
    abortController = new AbortController();
    const { signal } = abortController;
    // Debounce to do not send multiple requests in short time
    await new Promise(res => {
      setTimeout(() => {
        res();
      }, 200);
    });
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const devices = await res.json() ?? [];

    dispatch({
      type: DEVICES_AVAILABLE_FETCH_SUCCEEDED,
      payload: devices
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: DEVICES_AVAILABLE_FETCH_FAILED,
      error: e
    });
  }
};

export const clearDevicesAvailable = () => dispatch => {
  abortController.abort();
  dispatch({
    type: DEVICES_AVAILABLE_CLEAR
  });
};
